//-- React Standard
import React, { Component } from "react";
import { connect } from 'react-redux';
import Moment from 'moment';
import config from '../../config';
//-- Custom
import TopBar from "../Common/TopBar/TopBar";
import SideBar from "../Common/SideBar/SideBar";
import Footer from "../Common/Footer/Footer";
import { apiConstants } from '../../_constants/api.constants';
import Pagination from "../Common/Pagination/Pagination";
import PageLimit from "../Common/PageLimit/PageLimit";
import { orderActions } from "../../_actions";
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file

class ShopEarnings extends Component {
    constructor(props) {
        super(props);

        this.state = {
            sort: {
                sortKey: null,
                direction: 'desc',
            },
            totalPage: '',
            totalDataCount: '',
            currentPage: 1,
            orderData: [],
            perPage: 10,


            getCouponList: [],
            viewOpen: false,
            editOpen: false,
            deleteOpen: false,
            advertisments: {
                title: '',
                advertisment_image: '',
            },
            popupType: '',
            addButton: false,
            shopKeeperAdd: false,
            shopKeeperData: [],
            codEarn : 0,
            otherEarn : 0,
            colors : ["red"],
            showMonthAndYearPickers : true,
            startDate : new Date(),
            endDate : new Date(),
            showDatePicker : false,
            dataLoader : false
        };
    }

    /*
    * componentDidMount - Initially it will call and get the orders data
    */
    componentDidMount() {
        this.getOrdersConditionally(this.state.perPage, 1);
    }

    componentDidUpdate(prevProps, prevState) {
        const { match } = this.props;
        /**
        * this is the initial render
        * without a previous prop change
        */
       if(prevProps == undefined) {
           return false
       }

       /**
        * new Project in town ?
        */
       if (match.params.earningType != prevProps.match.params.earningType) {
        this.getOrdersConditionally(this.state.perPage, 1);
       }

   }

    //get orders common
    getOrdersConditionally = (perpage, pageNo) => {
        const { dispatch } = this.props;
        const { match } = this.props;

        let userData = JSON.parse(sessionStorage.getItem('user'));


        let postData = {};
        postData.page = pageNo;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = perpage;
        const merchantShopId = match.params.id;
        const earningType = match.params.earningType;
        const orderStatus = "order_completed_by_shopkeeper";
        if (userData.role_type[0] == 'shopkeeper') {
          postData.shopkeeperId = userData._id;
          postData.earningType = earningType;
          postData.orderStatus = orderStatus;
          postData.merchantShopId = userData.merchantShopId;
        }
        else if(merchantShopId !== undefined && earningType !== undefined) {
          postData.merchantShopId = merchantShopId;
          postData.earningType = earningType;
          postData.orderStatus = orderStatus;
        }
        else{}
        dispatch(orderActions.getAllOrders(apiConstants.GET_ALL_ORDERS, postData));
    }


    /*
    * componentWillReceiveProps - Whenever Props change, it will call and store data
    * update the state values with new props values, this method will get called whenever any change happens to props values
    */
    componentWillReceiveProps(props) {
        if (props.getAllOrders) {
            if (props.getAllOrders.orderList !== undefined &&
                props.getAllOrders.orderList.data !== undefined &&
                props.getAllOrders.orderList.data.allData !== undefined) {

                let orders = props.getAllOrders.orderList.data;
                this.setState({
                    orderData: orders.allData,
                    totalPage: orders.pagination.totalPages,
                    totalDataCount: orders.pagination.totalCount,
                    codEarn : orders.pagination.priceObject.codEarnings,
                    otherEarn : orders.pagination.priceObject.cardEarnings,
                    dataLoader : false
                })
            }
        }
    }


    /*
    *   Pagination function: It will call from pagination section and change data in table
    */
    makeHttpRequestWithPage = (pageNumber) => {
        this.setState({
            currentPage: pageNumber
        });

        this.getOrdersConditionally(this.state.perPage, pageNumber);
    }



    changeTableData = (e) => {
        this.getOrdersConditionally(parseInt(e.target.value), 1);
        this.setState({ perPage: parseInt(e.target.value) });
    }
    /*
    * searchOrders - User can search data from the database and it will appear
    */
    searchOrders(keyword, perpage, pageNo) {
        const { dispatch } = this.props;
        const { match } = this.props;
        let userData = JSON.parse(sessionStorage.getItem('user'));

        let postData = {};
        postData.page = pageNo;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = perpage;
        const shopkkeperId = match.params.id;
        const earningType = match.params.earningType;
        const orderStatus = "order_completed_by_shopkeeper";
        if (userData.role_type[0] == 'shopkeeper') {
          postData.shopkeeperId = userData._id;
          postData.earningType = earningType;
          postData.orderStatus = orderStatus;
        }
        else if(shopkkeperId !== undefined && earningType !== undefined) {
          postData.shopkeeperId = shopkkeperId;
          postData.earningType = earningType;
          postData.orderStatus = orderStatus;
        }
        else{}


        if (keyword.target.value !== '') {
            postData.search = keyword.target.value;
            dispatch(orderActions.getAllOrders(apiConstants.SEARCH_ORDER, postData));
        } else {
            dispatch(orderActions.getAllOrders(apiConstants.GET_ALL_ORDERS, postData));
        }
    }

    // viewOrderDetails = (orderId) => {
    //     const { history } = this.props;
    //     let url = '/order-details/' + orderId;
    //     history.push(url);
    // }
    handleSelect = (date) => {

        console.log("----date----",date.selection.startDate, date.selection.endDate);
        this.setState({ startDate: date.selection.startDate, endDate: date.selection.endDate, dataLoader : true});
        const { dispatch } = this.props;
        const { match } = this.props;

        let userData = JSON.parse(sessionStorage.getItem('user'));


        let postData = {};
        postData.page = 1;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = this.state.perPage;
        const shopkkeperId = match.params.id;
        const earningType = match.params.earningType;
        const orderStatus = "order_completed_by_shopkeeper";
        if (userData.role_type[0] == 'shopkeeper') {
          postData.shopkeeperId = userData._id;
          postData.earningType = earningType;
          postData.orderStatus = orderStatus;
          postData.startDate = date.selection.startDate;
          postData.endDate = date.selection.endDate;
        }
        else if(shopkkeperId !== undefined && earningType !== undefined) {
          postData.shopkeeperId = shopkkeperId;
          postData.earningType = earningType;
          postData.orderStatus = orderStatus;
          postData.startDate = date.selection.startDate;
          postData.endDate = date.selection.endDate;
        }
        else{}
        dispatch(orderActions.getAllOrders(apiConstants.GET_ALL_ORDERS, postData));

     }

     showDatePicker = () => {
       this.setState({ showDatePicker : !this.state.showDatePicker})
     }

     //redirect to order details
     viewOrderDetails = (orderId) => {
         const { history } = this.props;
         let url = '/order-details/' + orderId;
         history.push(url);
     }
    //-- Main function
    render() {
        const { siteConstants } = this.props.language;
        const { match, history } = this.props;
        const selectionRange = {
           startDate: this.state.startDate,
           endDate: this.state.endDate,
           key: 'selection',
         }
         let displayDatePick = "none";
         if(this.state.showDatePicker){
           displayDatePick = "block";
         }
        return (
            <div id="wrapper">

                <SideBar />

                <div id="content-wrapper" className="d-flex flex-column">
                    {/* <!-- Main Content --> */}
                    <div id="content">

                        <TopBar />
                        <nav className="" aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <a href="/dashboard">{siteConstants.GEN_DASHBOARD}</a>
                                </li>
                                <li className="active breadcrumb-item" aria-current="page">
                                    {siteConstants.GEN_SHOP_EARNINGS}
                                </li>
                            </ol>
                        </nav>

                        {/* <!-- Begin Page Content --> */}
                        <div className="container-fluid">

                            <div className="d-sm-flex align-items-center justify-content-between mb-4 mt-2">
                                <h1 className="h3 mb-0 text-gray-800 fontBold">{siteConstants.GEN_SHOP_EARNINGS}</h1>
                                <a href="javascript:void(0)" className="darkLink" onClick={() => history.goBack()}><i class="fa fa-angle-left"></i> {siteConstants.BTN_BACK}</a>
                            </div>
                            {/*<div className="d-sm-flex align-items-center justify-content-between mb-4 mt-2">
                                <h1 className="h3 mb-2 text-gray-800"></h1>
                                <a href="javascript:void(0)" className="darkLink" onClick={() => history.goBack()}><i class="fa fa-angle-left"></i> {siteConstants.BTN_BACK}</a>
                            </div>*/}

                            <div className="card shadow mb-4">
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <a href="javascript:void(0)" onClick={()=>this.showDatePicker()}>{siteConstants.DATE_BASED_FILTERING}</a> {this.state.dataLoader &&  <i class="fas fa-sync fa-spin"></i>}
                                        <div className="row" style={{display:displayDatePick}}>
                                          <DateRangePicker
                                             ranges={[selectionRange]}
                                             onChange={(date) => this.handleSelect(date)}
                                           />
                                         </div>
                                        <div className="row">
                                            {/* Page limit drop down */}
                                            <PageLimit changeLimit={(e) => this.changeTableData(e)} />

                                            <div className="col-sm-12 col-md-3">
                                                {match.params.earningType === "cod" ? siteConstants.GEN_COD_EARNINGS : siteConstants.GEN_OTHER_EARNINGS}
                                                : {config.currencyCode}{match.params.earningType === "cod" ? this.state.codEarn :this.state.otherEarn}
                                            </div>

                                            <div className="col-sm-12 col-md-3">
                                                <div id="dataTable_filter" className="dataTables_filter">
                                                    <label>
                                                        <input type="search" placeholder={siteConstants.SEARCH_ORDER_ID} className="form-control form-control-sm" aria-controls="dataTable" onChange={(e) => this.searchOrders(e, this.state.perPage, 1)} />
                                                    </label>
                                                </div>
                                            </div>
                                        </div>



                                        <table className="table table-bordered" width="100%" cellSpacing="0">
                                            <thead>
                                                <tr>
                                                    <th scope="col" width="5%">{siteConstants.GEN_NUMBER}</th>
                                                    <th scope="col" width="10%">{siteConstants.GEN_ORDER_CODE}</th>
                                                    <th scope="10%">{siteConstants.LABEL_DATE}</th>
                                                    <th scope="col">{siteConstants.LABEL_CUSTOMER}</th>
                                                    <th width="10%">{siteConstants.LABEL_ORDER_TOTAL}</th>
                                                    <th width="10%">{siteConstants.ORDER_TOTAL_PAID}</th>
                                                    <th scope="col">Payment Status</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.orderData != undefined &&
                                                        this.state.orderData.length > 0 ?
                                                        this.state.orderData.map((thisOrder, index) => {
                                                            let shopTitle = 'NA';
                                                            if (thisOrder.shopData !== undefined) {
                                                                shopTitle = thisOrder.shopData.map((shop, index) => {
                                                                    return shop.title;
                                                                })
                                                            }
                                                            return (

                                                                <tr key={index}>
                                                                    <td scope="row">{index + 1}</td>
                                                                    <td><a
                                                                        href="javascript:void(0)"
                                                                        onClick={(e) => this.viewOrderDetails(thisOrder._id)}
                                                                    >
                                                                        {thisOrder.orderNumber}</a>
                                                                    </td>
                                                                    <td> {Moment(thisOrder.createdAt).format(config.FullDateFormat)}</td>
                                                                    <td>
                                                                        {thisOrder.usersData[0].firstname} {thisOrder.usersData[0].lastname}
                                                                    </td>
                                                                    <td>{thisOrder.orderTotal !== undefined ? thisOrder.orderTotal : "-"}</td>
                                                                    <td>{thisOrder.pricepaid !== undefined ? thisOrder.pricepaid : "-"}</td>
                                                                    <td>{thisOrder.paymentStatus}</td>
                                                                </tr>
                                                            )
                                                        }) : <tr>
                                                            <td colSpan="7" className="noRecordFound">{siteConstants.GEN_NO_RECORD}</td>
                                                        </tr>
                                                }

                                            </tbody>
                                        </table>
                                    </div>
                                    {/* calling the another componenet */}
                                    <Pagination totalPage={this.state.totalPage} currentPage={this.state.currentPage} funPagination={this.makeHttpRequestWithPage} />



                                </div>
                            </div>

                        </div>
                        {/* <!-- /.container-fluid --> */}

                    </div>
                    {/* <!-- End of Main Content --> */}

                    <Footer />
                </div>


            </div >
        );
    }
}


//-- Here we are adding Reducer names, so it can be get data from reducers using store
function mapStateToProps(state) {
    const { getAllOrders, getCoupounList, language } = state;
    return {
        getAllOrders,
        getCoupounList,
        language
    };
}

const connectedOrders = connect(mapStateToProps)(ShopEarnings);
export { connectedOrders as ShopEarnings };
